import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
  createAgentThunk,
  createBaseKnowledgeThunk,
  deleteAgentThunk,
  getAgentByIdThunk,
  getAgentsThunk,
  getBaseKnowledgeThunk,
  getStatsAgentsThunk,
  getToolsThunk,
  updateAgentThunk,
} from "../actions/agent.action";
import { IAgent } from "../../models/agent.model";

export interface AgentState {
  agents: {
    agents: IAgent[];
    pagination: {
      totalItems: number;
      totalPages: number;
      pageSize: number;
      currentPage: number;
    };
  };
  agent: IAgent | null;
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: AgentState = {
  agents: {
    agents: [],
    pagination: {
      totalItems: 0,
      totalPages: 0,
      pageSize: 0,
      currentPage: 0,
    },
  },
  agent: null,
  loading: false,
  error: null,
};

// Dashboard slice
const agentSlice = createSlice({
  name: "agent",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAgentsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAgentsThunk.fulfilled, (state, action) => {
        state.agents = action.payload.data;
        state.loading = false;
      })
      .addCase(getAgentsThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(createAgentThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(createAgentThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createAgentThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(getStatsAgentsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStatsAgentsThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getStatsAgentsThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(getAgentByIdThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAgentByIdThunk.fulfilled, (state, action) => {
        state.agent = action.payload.data;
        state.loading = false;
      })
      .addCase(getAgentByIdThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(updateAgentThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateAgentThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateAgentThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(deleteAgentThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteAgentThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteAgentThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(getToolsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getToolsThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getToolsThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(createBaseKnowledgeThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(createBaseKnowledgeThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createBaseKnowledgeThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(getBaseKnowledgeThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBaseKnowledgeThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getBaseKnowledgeThunk.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
  },
});

export const { clearError } = agentSlice.actions;
export default agentSlice.reducer;
